<ng-template #article let-links="links">
    @for (link of links; track trackByPageViewModel) {
        <article class="article">
            <div class="article-content">
                <app-image [index]="$index" [image]="link.image" [height]="342" [width]="342" [indexLoadingThreshold]="8" crop="crop"></app-image>
                <footer>
                    <h3 class="title">{{ link.title }}</h3>
                    <app-arrow-link [link]="link" [cover]="true">
                        {{ data.goToLinkText }}
                    </app-arrow-link>
                </footer>
            </div>
        </article>
    }
</ng-template>
<div class="container">
    <h2 *ngIf="data.title || data.subtitle" class="headline">
        {{ data.title }}<span *ngIf="data.subtitle" class="children-count">{{ data.subtitle }}</span>
    </h2>
    <div *ngIf="!data.sortByPageType" class="row-wrapper">
        <ng-container *ngTemplateOutlet="article; context: { links: data.links }"></ng-container>
    </div>
    <ng-container *ngIf="data.sortByPageType">
        <div *ngFor="let linkWithPageType of data.links | groupByPageType | keyvalue">
            <h3 class="page-type-header">
                {{ linkWithPageType.key ? ('childrenLinks.category.' + linkWithPageType.key | translate) : '' }}
            </h3>
            <div class="row-wrapper">
                <ng-container *ngTemplateOutlet="article; context: { links: linkWithPageType.value }"></ng-container>
            </div>
        </div>
    </ng-container>
</div>
